import { DashboardMarket, DashboardMarketAsset, LINKS } from "@silo/types";
import { ReactNode } from "react";
import { cn } from "../../../utils/class-names";
import { StaticDescriptionContent } from "../../description";
import { ExternalLink } from "./external-link";
import { LendingLinkContext } from "../lending-link-context";

interface ActionContainerProps {
  className?: string;
  children?: ReactNode;
  market: DashboardMarket;
  asset: DashboardMarketAsset | undefined;
}

export function ActionContainer({
  className,
  children,
  market,
  asset,
}: ActionContainerProps): JSX.Element {
  const { marketAddress, isPaused } = market;
  const tokenAddress = asset?.tokenAddress;

  return (
    <div className={cn("flex flex-col gap-5", className)}>
      <div className="flex gap-2.5 lg:gap-8">
        <LendingLinkContext.Provider
          value={{ marketAddress, tokenAddress, disabled: isPaused }}
        >
          {children}
        </LendingLinkContext.Provider>
      </div>

      {isPaused && (
        <StaticDescriptionContent>
          <div className="flex flex-col items-start gap-5">
            <p>This action is temporarily disabled while the silo is frozen.</p>

            <div>
              <ExternalLink href={LINKS.SILOPEDIA.FROZEN_SILO} />
            </div>
          </div>
        </StaticDescriptionContent>
      )}
    </div>
  );
}
